














































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { SendPacket } from '@/networking/SendPacket';
import { PacketType } from '@/models/Packet';
import ElementQueries from 'css-element-queries';
import Timeline from '@/models/Timeline';
import Tag from "@/models/Tag";
import Vector3 from '@/models/Vector3';
import { mapGetters } from 'vuex';
import Node from '@/models/Node';
import Mutations from '@/store/mutations';
import BInputLimited from '@/components/input_limited/BInputLimited.vue';
import ColorSlider from '@/components/ColorSlider.vue';
import { getLegacyTagColor } from '@/util/LegacyTagColors';

@Component({
    computed: 
	{
	    ...mapGetters([
	        'checkTimelineWrite'
	    ]),
	},
    components: 
	{
	    BInputLimited,
	    ColorSlider
	}
})
export default class TagCircle extends Vue 
{
	@Prop(Tag) readonly tag? : Tag;
	@Prop(Timeline) readonly timeline? : Timeline;
	@Prop(Boolean) readonly undeletable! : Boolean; // default false
	@Prop(Boolean) readonly important! : Boolean; // default false
	@Prop(Boolean) readonly unclickable! : Boolean; // default false

	hovered = false;
	focused = false;
	editFocused = false;

	mouseEnter()
	{
	    this.$nextTick(() =>
	    {
	        this.hovered = true;
	    });
	}

	mouseLeave()
	{
	    this.hovered = false;
	    this.editFocused = false;
	    this.customBlur(this.$refs.tagBtn as any);
	}

	onLoseFocus()
	{
	    setTimeout(() => 
	    {
	        this.$nextTick(() =>
	        {
	            if (!this.editFocused)
	                this.focused = false;
	        });
	    }, 100);
	}

	onColorInput(something : any)
	{
	    console.log(something);
	}
	
	deleteCategory()
	{
	    if (this.timeline == undefined || this.tag == undefined)
	        return;

	    console.log(`Attempting to delete tag ${this.tag.name}`);
	    SendPacket(PacketType.TimelineRemoveTag, 
	        {
	            timelineid: this.timeline.id,
	            tagid: this.tag.tagid
	        });
	    for (let nodeID of this.timeline.nodeIDs)
	    {
	        let node = this.$store.state.project.nodes.get(nodeID) as Node;
	        if (node)
	        {
	            for (let tag of node.tags)
	            {
	                if (tag.tagid == this.tag.tagid)
	                {
	                    let data =
						{
						    nodeid: node.nodeid,
						    tagid: this.tag.tagid
						};
	                    this.$store.commit(Mutations.removeNodeTag, data);
	                    SendPacket(PacketType.NodeRemoveTag, data);
	                }
	            }
	        }
	    }
	}

	customBlur(el : HTMLElement)
	{
	    el.blur();
	}

	get editName() : string
	{
	    return ((this.tag != null) ? this.tag.name : '');
	}
	set editName(value: string)
	{
	    if (this.tag != null && this.tag.name !== value)
	    {
	        this.tag.name = value;
	        SendPacket(PacketType.TagUpdateTitle, { tagid: this.tag.tagid, name: this.tag.name });
	    }
	}

	get colorString()
	{
	    if (this.tag == null)
	    {
	        return 'background-color: #9299A5;';
	    }
	    else if (this.tag.filtered)
	    {
	        return 'background-color: rgb(32, 32, 32);';
	    }
	    else
	    {
	        let tgCol = this.tag.color;
	        if (!tgCol)
	        {
	            tgCol = getLegacyTagColor(this.tag.tagid);
	        }
	        return `background-color: rgb(${tgCol.r}, ${tgCol.g}, ${tgCol.b});`;
	    }
	}

	get ariaString()
	{
	    if (this.tag != undefined)
	    {
	        return `this event's category is ${this.tag.name}`;
	    }
	    else
	    {
	        return `this event has not been categorized`;
	    }
	}

	get tooltipString()
	{
	    if(this.tag == null || this.tag == undefined)
	    {
	        return '';
	    }
		
	    if(this.tag.filtered)
	    {
	        return 'click to unhide';
	    }
	    else
	    {
	        return 'click to hide events';
	    }
	}
}
